import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const ExportRouteMaster = ({ routeData = [] }) => {
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Route List");
    const boldFont = { bold: true };

    const downloadDateTime = `Route List Generated on: ${new Date().toLocaleString()}`;
    worksheet.addRow(["", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 8);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Route Code",
      "Route Description",
      "Ward",
      "Vehicle",
      "Route Type",
      "Stoppage",
      "Distance",
      "From Date",
      "To Date",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "003366" },
      };
    });

    routeData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.routeCode || "N/A",
          item.routeDescription || "N/A",
          item.ward || "N/A",
          item.vehicle || "N/A",
          item.routeType || "N/A",
          item.stoppage ?? "N/A",
          item.distance || "N/A",
          item.fromDate || "N/A",
          item.toDate || "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = { horizontal: "center" };
        });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "RouteList.xlsx";
    anchor.click();
    URL.revokeObjectURL(url);
  };

  const exportToPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("Route List", 14, 20);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 28);

    autoTable(doc, {
      startY: 35,
      head: [[
        "S.No",
        "Route Code",
        "Description",
        "Ward",
        "Vehicle",
        "Route Type",
        "Stoppage",
        "Distance",
        "From Date",
        "To Date",
      ]],
      body: routeData.map((row, index) => [
        index + 1,
        row.routeCode || "N/A",
        row.routeDescription || "N/A",
        row.ward || "N/A",
        row.vehicle || "N/A",
        row.routeType || "N/A",
        row.stoppage ?? "N/A",
        row.distance || "N/A",
        row.fromDate || "N/A",
        row.toDate || "N/A",
      ]),
      headStyles: {
        fillColor: [0, 51, 102],
        textColor: [255, 255, 255],
        fontSize: 8,
        halign: "center",
      },
      bodyStyles: { fontSize: 7, halign: "center" },
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
        valign: "middle",
      },
      theme: "grid",
    });

    doc.save("RouteList.pdf");
  };

  return (
    <>
      <button type="button" onClick={exportToExcel} className="button-container ms-3">
        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
      <button type="button" onClick={exportToPDF} className="button-container ms-3">
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>
    </>
  );
};

export default ExportRouteMaster;
